import React from 'react';
import { observer } from 'mobx-react-lite';
import { Toast } from 'flowbite-react';
import { HiCheck, HiX, HiInformationCircle, HiExclamation } from 'react-icons/hi';
import { toastStore } from '../stores/toastStore';

const ToastContainer: React.FC = observer(() => {
  const getIcon = (type: string) => {
    switch (type) {
      case 'success':
        return <HiCheck className="h-5 w-5" />;
      case 'error':
        return <HiX className="h-5 w-5" />;
      case 'warning':
        return <HiExclamation className="h-5 w-5" />;
      case 'info':
      default:
        return <HiInformationCircle className="h-5 w-5" />;
    }
  };

  const getColorClass = (type: string) => {
    switch (type) {
      case 'success':
        return 'bg-green-100 text-green-500 dark:bg-green-800 dark:text-green-200';
      case 'error':
        return 'bg-red-100 text-red-500 dark:bg-red-800 dark:text-red-200';
      case 'warning':
        return 'bg-yellow-100 text-yellow-500 dark:bg-yellow-800 dark:text-yellow-200';
      case 'info':
      default:
        return 'bg-blue-100 text-blue-500 dark:bg-blue-800 dark:text-blue-200';
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-4">
      {toastStore.toasts.map((toast) => (
        <Toast key={toast.id}>
          <div className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${getColorClass(toast.type)}`}>
            {getIcon(toast.type)}
          </div>
          <div className="ml-3 text-sm font-normal">{toast.message}</div>
          <Toast.Toggle onDismiss={() => toastStore.removeToast(toast.id)} />
        </Toast>
      ))}
    </div>
  );
});

export default ToastContainer;